// extracted by mini-css-extract-plugin
module.exports = {"text":"no-ingredient_text__2kuLw"};